import React from 'react';

import { PaymentListDataDisplay } from './PaymentListDataDisplay';
import { BreadcrumbPayment } from './BreadcrumbPayment';
import { TimestampConverter } from '../../PatientFormContainer/pages/PatientInfoPage/functions/TimestampConverter';
import { Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';



export const PaymentListHeader = ({
    selectedItem, setSelectedItem, // setSelectedItem = {userID: 'userID', hospID: 'hospID'}
    currentList, lang, opMode
}) => {

    const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch (err) {
        console.error('Failed to copy text: ', err);

    }
};

    const selectedPaymentList = !!(selectedItem?.hospID) ? currentList?.paymentList?.find((hosp) => hosp?.hospID === selectedItem?.hospID) : currentList;

    const parsedPaymentDate = currentList?.paymentDate ? new Date(currentList?.paymentDate) : null;
    const formatPaymentDate = TimestampConverter(parsedPaymentDate, true);


    const USDValue = selectedPaymentList?.GOPTotalUSD;
    const TLValue = selectedPaymentList?.GOPTotalTL / 100;
    const totalCount = selectedPaymentList?.totalCount;

    const queryClient = useQueryClient();
    const validateData = queryClient.getQueryData(['validate']);
    const confirmedUserID = validateData?.data?.userID;

    const userList = queryClient.getQueryData(['hospitalUserList']);

    const userData = selectedItem?.userID && userList?.data?.find((user) => user.value === selectedItem?.userID);

    const AdminMode = (confirmedUserID === 'Admin');


    return (
        !!totalCount && totalCount > 0 ? <div className='paymentListHeaderWrapper' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: '0.65rem 0.25rem', }}>

            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', justifyContent: 'flex-start', width: '100%', flexGrow: 1 }}>

                {formatPaymentDate && <div className='breadcrumbWrapper'>
                    <BreadcrumbPayment
                        rootLabel={formatPaymentDate}
                        selectedItem={selectedItem}
                        clearSelectedItem={() => setSelectedItem({ hospID: null, userID: null })}
                        lang={lang}
                    />
                </div>}

               {AdminMode && userData && userData?.IBAN &&
               <div style={{display:'flex'}}>

                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white', userSelect: 'none', pointerEvents: 'auto',cursor: 'pointer', }}
                     onClick={() => copyToClipboard(userData?.IBAN ? `${userData?.IBAN}` : '')}
                    >
                        {userData?.IBAN}
                    </Typography>
                </div>}

            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', justifyContent: 'flex-start', width: '100%', flexGrow: 1 }}>

                {(selectedPaymentList) &&
                    <PaymentListDataDisplay
                        lang={lang}
                        opMode={opMode}
                        USDValue={USDValue}
                        TLValue={TLValue}
                        totalCount={totalCount}
                    />}

            </div>
        </div> : null);
}



